export const UPLOADED_AUDIO = 'fullmix';
export const EXISTING_VOICEOVER = 'existingVO';
export const NEW_VOICEOVER = 'newVO';
export const BG_MUSIC = 'bgmusic';
export const DEFAULT_AUDIO = UPLOADED_AUDIO;
export const EXISTING_VO_BG_MUSIC = 'existingVOBgmusic';

export const AUDIO_NAME = {
  [UPLOADED_AUDIO]: 'User Uploaded Audio',
  [EXISTING_VOICEOVER]: 'Existing Voiceover',
  [NEW_VOICEOVER]: 'New Voiceover',
};



// WEBPACK FOOTER //
// ./src/config/audioTypes.js